import { Navigate } from "react-router-dom";
import { getToken } from "../services/tokenService";

const ProtectedRoute = ({ children }) => {
  const token = getToken();

  if (!token) {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;